import { createSlice } from '@reduxjs/toolkit'

export const clientsSlice = createSlice({
    name: 'clients',
    initialState: {
        result: [],
    },
    reducers: {
        setClients: (state, action) => {
            state.result = action.payload;
        },
        clearClients: (state) => {
            state.result = [];
        }
    },
})

export const { setClients, clearClients } = clientsSlice.actions;

export const getClients = (state) => state.clients.result;

export default clientsSlice.reducer